// Same lookup as iOS: the default version's URL, falling back to the legacy `url` field.
export const songAudioUrl = (song) => {
  const version = song.versions && song.versions[song.defaultVersion || 'v1'];
  return (version && version.url) || song.url || "";
};
